import UserBookingWalletBalance from './UserBookingWalletBalance';
import { Spin } from 'antd';
import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { costString } from '../../../../utils/cost';

const spinIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

export default function UserBookingPaymentTotal({
  loading,
  cost,
  walletEnabled = false,
  usingWalletAmountPence = null,
  setUsingWalletAmountPence = () => {},
}) {
  const walletAmountUsed = (usingWalletAmountPence ?? 0) / 100;

  const payableTotal = cost?.isDiscounted ? cost.discountedTotal : cost.total;
  const payablePence = (cost?.advance > 0 ? cost.advance : payableTotal) * 100;

  const walletComponent = walletEnabled && (
    <UserBookingWalletBalance
      payableAmountPence={payablePence}
      amountInUse={usingWalletAmountPence}
      setUsingWalletAmountPence={setUsingWalletAmountPence}
    />
  );

  const hasDeposit = Boolean(cost?.advance) && cost.advance < payableTotal;
  const isStandardCosting = !cost?.isDiscounted && !hasDeposit;

  if (loading || isStandardCosting) {
    return (
      <>
        <p className='txt-center'>
          <span className='gSemiBold fs-23'>Payment Total:</span>{' '}
          {Boolean(walletAmountUsed) && (
            <span className={'gMedium grey fs-20 mg-left-10 txt-strikethrough'}>
              {costString(cost.total)}
            </span>
          )}
          <span className='gSemiBold sb-blue fs-30 mg-left-10'>
            {loading ? (
              <Spin indicator={spinIcon} />
            ) : (
              costString(payableTotal - walletAmountUsed)
            )}
          </span>
        </p>
        {walletComponent}
      </>
    );
  }

  return (
    <>
      <p className='txt-center mg-bottom-5'>
        <span className='gSemiBold fs-19'>Payment Total:</span>{' '}
        <span
          className={
            'gMedium sb-black fs-26 mg-left-10 ' +
            (cost.isDiscounted ? ' txt-strikethrough ' : '')
          }
        >
          {costString(cost.total)}
        </span>
      </p>
      {cost.isDiscounted && (
        <p
          className={
            'row-center justify-center ' + (hasDeposit ? ' mg-bottom-5 ' : '')
          }
        >
          <p className='mg-bottom-0 sb-blue-bg brFull gBold txt-center fs-14 white pd-2 pd-left-15 pd-right-15'>
            Promotion Applied
          </p>
          <span
            className={
              'gSemiBold sb-blue mg-left-10 ' +
              (hasDeposit ? ' fs-26 ' : ' fs-30 ')
            }
          >
            {costString(
              hasDeposit ? payableTotal : payableTotal - walletAmountUsed
            )}
          </span>
        </p>
      )}
      {hasDeposit && (
        <p className='txt-center'>
          <span className='gSemiBold fs-23'>Pay Today:</span>{' '}
          <span className='gMedium sb-black fs-30 mg-left-10'>
            {costString(cost.advance - walletAmountUsed)}
          </span>
        </p>
      )}
      {walletComponent}
    </>
  );
}
